<template>
  <div id="features">
    <div class="container-fluid">
      <div class="row">
        <div
          role="main"
          class="col d-block pt-2"
        >
          <section class="pt-3">
            <div class="section-title">
              XML Features
            </div>
            <div class="row d-block">
              <div class="col">
                <div class="row mt-3">
                  <div class="col-12 col-xl-6">
                    <h5 class="d-flex align-items-center justify-content-between">
                      Existing Mappings
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click.prevent="modeNewMapping = true"
                      >
                        Add Mapping
                      </button>
                    </h5>
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th scope="col">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Text Filter"
                              v-model="searchMappingText"
                              @input="filterMappings"
                            >
                          </th>
                          <th scope="col">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="Code Filter"
                              v-model="searchMappingCode"
                              @input="filterMappings"
                            >
                          </th>
                          <th scope="col" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="mapping in filteredMappings"
                          :key="mapping.id"
                        >
                          <td>{{ mapping.attribute }}</td>
                          <td>{{ mapping.code }}</td>
                          <td>
                            <button
                              class="btn btn-link p-0 btn-sm"
                              @click.prevent="removeMapping(mapping.id)"
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col-12 col-xl-6">
                    <h5 class="d-flex align-items-center justify-content-between">
                      Existing Features
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click.prevent="modeNewFeature = true"
                      >
                        Add Feature
                      </button>
                    </h5>
                    <table class="table table-striped table-sm">
                      <thead>
                        <tr>
                          <th scope="col">
                            Feature
                          </th>
                          <th scope="col">
                            Description
                          </th>
                          <th scope="col" />
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="feature in features"
                          :key="feature.key"
                        >
                          <td>{{ feature.key }}</td>
                          <td>{{ feature.description }}</td>
                          <td>
                            <button
                              class="btn btn-link p-0 btn-sm"
                              @click.prevent="featureToUpdate = feature; modeUpdateFeature = true;"
                            >
                              Update
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <button
                      class="btn btn-outline-primary"
                      @click.prevent="modeNewFeature = true"
                    >
                      Add Feature
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div class="clearfix" />
        </div>
        <div class="clearfix" />
      </div>
    </div>
    <div
      id="newMapping"
      :class="`modal fade px-0 ${ modeNewMapping ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Add new mapping
            </h5>
            <button
              type="button"
              class="close"
              @click="closeAddNewMapping"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body container-fluid text-center">
            <form @submit.prevent="addNewMapping">
              <div class="row">
                <div
                  class="col-6"
                >
                  <input
                    type="attribute"
                    class="form-control"
                    v-model="newMappingText"
                    placeholder="Mapping Text"
                    required
                  >
                </div>
                <div class="col-6">
                  <select
                    class="custom-select form-control"
                    v-model="newMappingCode1"
                    required
                  >
                    <option value="">
                      Select Feature...
                    </option>
                    <option
                      v-for="feature in features"
                      :value="feature.key"
                      :key="feature.key"
                    >
                      {{ feature.key }} ({{ feature.description }})
                    </option>
                  </select>
                  <sub>
                    <button
                      class="btn btn-link p-0"
                      v-if="multiFeatureMapping == false"
                      @click.prevent="multiFeatureMapping = true"
                    >
                      Add Another
                    </button>
                  </sub>
                  <sub>
                    <button
                      class="btn btn-link p-0"
                      v-if="multiFeatureMapping == true"
                      @click.prevent="multiFeatureMapping = false;newMappingCode2=''"
                    >
                      cancel
                    </button>
                  </sub>
                  <br>
                  <select
                    class="custom-select form-control"
                    v-if="multiFeatureMapping == true"
                    v-model="newMappingCode2"
                  >
                    <option value="">
                      Select Feature...
                    </option>
                    <option
                      v-for="feature in features"
                      :value="feature.key"
                      :key="feature.key"
                    >
                      {{ feature.key }} ({{ feature.description }})
                    </option>
                  </select>
                </div>
                <div
                  data-field-button=""
                  class="col-12"
                >
                  <button
                    class="btn btn-primary btn-block mt-2"
                    type="submit"
                    :disabled="isAddNewMappingFormInSubmission"
                  >
                    Add
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      id="newFeature"
      :class="`modal fade px-0 ${ modeNewFeature ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Add new feature
            </h5>
            <button
              type="button"
              class="close"
              @click.prevent="modeNewFeature = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body container-fluid">
            <form
              @submit.prevent="addFeature"
            >
              <div class="form-group">
                <label for="key">Feature key</label>
                <input
                  id="key"
                  type="attribute"
                  class="form-control"
                  v-model="newFeatureText"
                  pattern="^[a-z][a-z-]{1,20}[a-z]$"
                  placeholder="e.g. pool, air-conditioning"
                  required
                >
              </div>
              <div class="form-group">
                <label for="desc">Feature description</label>
                <input
                  id="desc"
                  type="attribute"
                  class="form-control"
                  v-model="newFeatureDescription"
                  placeholder="e.g Swimming pool"
                  required
                >
              </div>
              <div class="form-group">
                <label for="en">Label in english</label>
                <input
                  id="en"
                  type="attribute"
                  class="form-control"
                  v-model="newFeatureLabelEN"
                  placeholder="e.g English Label"
                  required
                >
              </div>
              <div class="form-group">
                <label for="es">Label in spanish</label>
                <input
                  id="es"
                  type="attribute"
                  class="form-control"
                  v-model="newFeatureLabelES"
                  placeholder="e.g Spanish Label"
                  required
                >
              </div>
              <button
                class="btn btn-primary btn-block mt-2"
                type="submit"
                :disabled="isAddNewFeatureFormInSubmission"
              >
                Add
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      id="updateFeature"
      :class="`modal fade px-0 ${ modeUpdateFeature ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Update feature
            </h5>
            <button
              type="button"
              class="close"
              @click.prevent="modeUpdateFeature = false"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            class="modal-body container-fluid"
            v-if="featureToUpdate != null"
          >
            <p>Updating feature with a key/code: <strong><u>{{ featureToUpdate.key }}</u></strong></p>
            <form
              @submit.prevent="updateFeature"
            >
              <div class="form-group">
                <label for="desc">Feature description</label>
                <input
                  id="desc"
                  type="attribute"
                  class="form-control"
                  v-model="featureToUpdate.description"
                  placeholder="e.g Swimming pool"
                  required
                >
              </div>
              <div class="form-group">
                <label for="en">Label in english</label>
                <input
                  id="en"
                  type="attribute"
                  class="form-control"
                  v-model="featureToUpdate.labels.en"
                  placeholder="e.g English Label"
                  required
                >
              </div>
              <div class="form-group">
                <label for="es">Label in spanish</label>
                <input
                  id="es"
                  type="attribute"
                  class="form-control"
                  v-model="featureToUpdate.labels.es"
                  placeholder="e.g Spanish Label"
                  required
                >
              </div>
              <button
                class="btn btn-primary btn-block mt-2"
                type="submit"
                :disabled="isUpdateFeatureFormInSubmission"
                @click.prevent="updateFeature"
              >
                Update
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from '../../../http';
import notify from '../../../notifications';

export default {
    data() {
        return {
            isAddNewFeatureFormInSubmission: false,
            isAddNewMappingFormInSubmission: false,
            isUpdateFeatureFormInSubmission: false,
            featureToUpdate: null,
            top: 1000,
            newMappingText: '',
            newMappingCode1: '',
            newMappingCode2: '',
            newFeatureText: '',
            newFeatureDescription: '',
            newFeatureLabelEN: '',
            newFeatureLabelES: '',
            modeNewFeature: false,
            modeNewMapping: false,
            modeUpdateFeature: false,
            multiFeatureMapping: false,
            allMappings: [],
            filteredMappings: [],
            filteredUnmapped: [],
            features: [],
            searchMappingText: '',
            searchMappingCode: '',
        };
    },
    methods: {
        async addMapping( feature ) {
            this.modeNewMapping = true;
            this.newMappingText = feature;
        },
        async addFeature() {
            this.isAddNewFeatureFormInSubmission = true;
            this.$store.dispatch( 'appLoading', true );

            let data = {
                Key: this.newFeatureText,
                Description: this.newFeatureDescription,
                Labels: {
                    'en': this.newFeatureLabelEN,
                    'es': this.newFeatureLabelES
                }
            };

            const response = await http.post( '/feature', data );

            if ( response.status === 200 ) {
                this.modeNewFeature = false;
                this.newFeatureText = '';
                this.newFeatureDescription = '';
                this.newFeatureLabelEN = '';
                this.newFeatureLabelES = '';
                await this.getFeatures();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to add new feature'
                } );
            }
            this.isAddNewFeatureFormInSubmission = false;
            this.$store.dispatch( 'appLoading', false );
        },
        async updateFeature() {
            this.isUpdateFeatureFormInSubmission = true;
            this.$store.dispatch( 'appLoading', true );

            const response = await http.post( '/feature/' + this.featureToUpdate.id, this.featureToUpdate );

            if ( response.status === 200 ) {
                this.modeUpdateFeature = false;
                await this.getFeatures();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to update new feature'
                } );
            }
            this.isUpdateFeatureFormInSubmission = false;
            this.$store.dispatch( 'appLoading', false );
        },
        async closeAddNewMapping() {
            this.modeNewMapping = false;
            this.newMappingText = '';
            this.newMappingCode1 = '';
            this.newMappingCode2 = '';
            this.multiFeatureMapping = '';
        },
        async filterMappings() {
            let filtered = this.allMappings;

            if ( this.searchMappingText.length > 0 ) {
                filtered = filtered.filter( f => f.attribute.toLowerCase().includes( this.searchMappingText.toLowerCase() ) );
            }

            if ( this.searchMappingCode.length > 0 ) {
                filtered = filtered.filter( f => f.code.toLowerCase().includes( this.searchMappingCode.toLowerCase() ) );
            }

            this.filteredMappings = filtered;
        },
        async getMappings() {
            const response = await http.get( '/featuremapping' );

            if ( response.status === 200 ) {
                this.allMappings = await response.json();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to get mappings'
                } );
            }
        },
        async removeMapping( mappingId ) {
            this.$store.dispatch( 'appLoading', true );
            const response = await http.delete( '/featuremapping/' + mappingId );

            if ( response.status === 200 ) {
                await this.loadMappings();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to remove mapping'
                } );
            }
            this.$store.dispatch( 'appLoading', false );
        },
        async addNewMapping() {
            this.isAddNewMappingFormInSubmission = true;
            let codes = [ this.newMappingCode1 ];

            if ( this.newMappingCode2.length > 0 ) {
                codes.push( this.newMappingCode2 );
            }

            this.$store.dispatch( 'appLoading', true );

            for ( var code of codes ) {
                let data = {
                    Attribute: this.newMappingText,
                    Code: code
                };

                const response = await http.post( '/featuremapping', data );

                if ( response.status !== 200 ) {
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to add new mapping'
                    } );
                }
            }

            this.closeAddNewMapping();
            await this.loadMappings();

            this.isAddNewMappingFormInSubmission = false;
            this.$store.dispatch( 'appLoading', false );
        },
        async getFeatures() {
            const response = await http.get( '/feature' );

            if ( response.status === 200 ) {
                this.features = await response.json();
            } else {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load features'
                } );
            }
        },
        async loadMappings() {
            await Promise.all( [
                this.getMappings()
            ] );

            this.filterMappings();
        }
    },
    async mounted() {
        this.$store.dispatch( 'appLoading', true );

        await Promise.all( [
            this.getFeatures(),
            this.loadMappings()
        ] );

        this.$store.dispatch( 'appLoading', false );
        document.title = 'thinkSPAIN - XML Features';
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/features/index.vue